











import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { SkuSummary } from '@/usecases/novelty/sku-summary'
import { PluginMixin } from '@spa/mixins/plugin'
import NoveltyItem from './NoveltyItem.vue'

@Component({
  components: {
    NoveltyItem,
  },
})
export default class ReadOnlyNoveltyItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  summary: SkuSummary

  get show(): boolean {
    return this.summary.selection.count > 0
  }
}
